import React, { useState } from "react";
import "./WaterPurifierService.css";
import customer1 from "../images/cutomer1.webp";
import FilterReplacement from "../images/Filter Replacement.webp";
import PurifierMaintenance from "../images/PurifierMaintenance.webp"
import PurifierInstallation from "../images/Purifier Installation.webp";
import ros from "../images/ross.jpg"
import DoorstepPurifierService from "../images/ros.webp";
import ROSystemService from "../images/ro hero.webp";
import ro_service2 from "../images/ro_service2.webp";



function WaterPurifier() {
  
    const [formData, setFormData] = useState({
      name: "",
      phone: "",
      location: "",
      issue: "",
    });
  
    const [loading, setLoading] = useState(false);
  
    const handleChange = (e) => {
  
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
  
    };
  
    const handleSubmit = async (e) => {
  
      e.preventDefault();
  
      setLoading(true);
  
      const sendData = {
        ...formData,
        toMail: "expresshelplinecare@gmail.com",
      };
  
      try {
  
        const res = await fetch(
          "https://form.e2ecrm.in/api/sendmail",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(sendData),
          }
        );
  
        await res.json();
  
        alert(
          "Thank you! Your service request is confirmed. Our engineer will call you shortly."
        );
  
        setFormData({
          name: "",
          phone: "",
          location: "",
          issue: "",
        });
  
      } catch (err) {
  
        console.log(err);
  
        alert("Error sending form");
  
      } finally {
  
        setLoading(false);
  
      }
    };
  
  return (
   <>
   
  
      {/* SPINNER */}

      {loading && (

        <div className="spinner-overlay">

          <div className="spinner"></div>

        </div>

      )}

      {/* WATER PURIFIER HERO SECTION */}

      <div className="purifier-home">

        <section className="purifier-hero">

          {/* LEFT APPLIANCE */}

          <div className="purifier-appliance-section">

            {/* <img
              className="purifier-machine-img"
              src="https://cdn-icons-png.flaticon.com/512/2966/2966480.png"
              alt="Water Purifier Service"
            /> */}

          </div>

          {/* CONTENT */}

          <div className="purifier-content">

            <h1>
              Water Purifier <br />
              Repair & <br />
              Maintenance <br />
              Service At <br />
              Your Doorsteps
            </h1>

          </div>

          {/* FORM */}

          <div className="purifier-booking-form">

            <h2>
              +91 93639 29984
            </h2>

            <p>
              CALL US TODAY
            </p>

            <span>
              Register your water purifier service complaints
            </span>

            <form onSubmit={handleSubmit}>

              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="location"
                placeholder="Location"
                value={formData.location}
                onChange={handleChange}
                required
              />

              <textarea
                name="issue"
                placeholder="Describe the water purifier issue..."
                value={formData.issue}
                onChange={handleChange}
              ></textarea>
          <p>Your personal information is handled responsibly and used only for the services you request.</p>

              <button type="submit">

                {loading ? "Sending..." : "SUBMIT"}

              </button>

            </form>

          </div>

        </section>

      </div>

{/* WATER PURIFIER ABOUT SECTION */}

<section className="purifier-about-section">

  <div className="purifier-about-left">

    <h1>
      Trusted Water <br />
      Purifier Repair <br />
      Experts for <br />
      Your Home <br />
      Needs
    </h1>

    <div className="purifier-about-box">

      <p>
        With 8+ years of experience in water purifier repair,
        our technicians provide fast and reliable doorstep support.
      </p>

      <p>
        From filter replacement to RO and UV system issues,
        we repair all major water purifier brands professionally.
      </p>

    </div>

  </div>

  <div className="purifier-about-right">

    <h4>
      OUR SERVICE ACHIEVEMENTS
    </h4>

    <div className="purifier-counter-grid">

      <div className="purifier-counter-box">
        <h1>8+</h1>
        <p>Years Experience</p>
      </div>

      <div className="purifier-counter-box">
        <h1>28000+</h1>
        <p>Purifier Repairs</p>
      </div>

      <div className="purifier-counter-box">
        <h1>60+</h1>
        <p> Experienced Technicians </p>
      </div>

      <div className="purifier-counter-box">
        <h1>20+</h1>
        <p>Multiple Service Areas Covered</p>
      </div>

    </div>

  </div>

</section>


{/* WATER PURIFIER SERVICES SECTION */}

<section className="purifier-services-section">

  <h1 className="purifier-service-title">
    Our Water Purifier Services
  </h1>

  <div className="purifier-services-grid">

    {/* CARD 1 */}

    <div className="purifier-service-card">

      <img
        src={FilterReplacement} alt="filter issue"
      />

      <h2>
        Filter Replacement
      </h2>

      <p>
        Professional filter replacement support
        for RO, UV, and UF water purifiers.
      </p>

    </div>

    {/* CARD 2 */}

    <div className="purifier-service-card">

      <img
        src={PurifierMaintenance}
        alt="water purifier maintenance"
      />

      <h2>
        Purifier Maintenance
      </h2>

      <p>
        Regular servicing and maintenance support
        to improve water purifier performance.
      </p>

    </div>

    {/* CARD 3 */}

    <div className="purifier-service-card">

      <img
        src={PurifierInstallation}
        alt="installation"
      />

      <h2>
        Purifier Installation
      </h2>

      <p>
        Safe water purifier installation and setup
        support for homes and offices.
      </p>

    </div>

    {/* CARD 4 */}

    <div className="purifier-service-card">

      <img
        src={ros} alt="water leakage"
      />

      <h2>
        Leakage Repair
      </h2>

      <p>
        Fast repair support for water leakage,
        low water flow, and motor issues.
      </p>

    </div>

    {/* CARD 5 */}

    <div className="purifier-service-card">

      <img
        src={ROSystemService} alt="ro service"
      />

      <h2>
        RO System Service
      </h2>

      <p>
        Expert support for RO membrane,
        candle filter, and purification issues.
      </p>

    </div>

    {/* CARD 6 */}

    <div className="purifier-service-card">

      <img
        src={DoorstepPurifierService}  alt="doorstep purifier service"
      />

      <h2>
        Doorstep Purifier Service
      </h2>

      <p>
        Quick doorstep water purifier repair support
        from experienced technicians.
      </p>

    </div>

  </div>

</section>

{/* WATER PURIFIER WHY CHOOSE US */}

<section className="purifier-choose-section">

  <div className="purifier-choose-overlay">

    <h4>
      WHY CHOOSE OUR WATER PURIFIER SERVICE
    </h4>

    <h1>
      Trusted Water Purifier <br />
      Repair Solutions
    </h1>

    <div className="purifier-choose-grid">

      {/* BOX 1 */}

      <div className="purifier-choose-box">

        <div className="purifier-choose-icon">
          💧
        </div>

        <h2>
          Expert Purifier Repair
        </h2>

      </div>

      {/* BOX 2 */}

      <div className="purifier-choose-box">

        <div className="purifier-choose-icon">
          ⏰
        </div>

        <h2>
          Same Day Service
        </h2>

      </div>

      {/* BOX 3 */}

      <div className="purifier-choose-box">

        <div className="purifier-choose-icon">
          💰
        </div>

        <h2>
          Affordable Pricing
        </h2>

      </div>

      {/* BOX 4 */}

      <div className="purifier-choose-box">

        <div className="purifier-choose-icon">
          🚚
        </div>

        <h2>
          Doorstep Support
        </h2>

      </div>

      {/* BOX 5 */}

      <div className="purifier-choose-box">

        <div className="purifier-choose-icon">
          ⚙️
        </div>

        <h2>
          Pure Water Solutions
        </h2>

      </div>

      {/* BOX 6 */}

      <div className="purifier-choose-box">

        <div className="purifier-choose-icon">
          👨‍🔧
        </div>

        <h2>
          Experienced Technicians
        </h2>

      </div>

    </div>

  </div>

</section>



<section className="purifier-request-section">

  {/* Left Content */}

  <div className="purifier-request-left">

    <h1>
      Water Purifier <br />
      Repair Support
    </h1>

    <h2>
      Fast & Reliable <br />
      Water Purifier Service at <br />
      Your Doorstep
    </h2>

    <p>
      We provide complete water purifier repair and maintenance
      solutions for homes and offices. Our experienced
      technicians handle filter replacement, water leakage,
      RO membrane issues, low water flow,
      and servicing with professional
      doorstep support at affordable pricing.
    </p>

  </div>

  {/* Right Image */}

  <div className="purifier-request-right">

    <img
      src={ro_service2}
      alt="water purifier repair service"
    />

  </div>

</section>

{/* WATER PURIFIER CUSTOMER SUPPORT */}

{/* <section className="purifier-support-section">

 

  <div className="purifier-support-image">

    <img
      src={customer1} alt="water purifier customer support"
    />

  </div>

 

  <div className="purifier-support-content">

    <h1>
      Water Purifier Customer Support
    </h1>


    <div className="purifier-support-box">
      <span>+</span>
      <p>Quick Booking Through Call & WhatsApp</p>
    </div>

    <div className="purifier-support-box">
      <span>+</span>
      <p>Same Day Technician Visit</p>
    </div>

    <div className="purifier-support-box">
      <span>+</span>
      <p>Professional RO & UV Purifier Support</p>
    </div>

    <div className="purifier-support-box">
      <span>+</span>
      <p>Experienced Water Purifier Technicians</p>
    </div>

    <div className="purifier-support-box">
      <span>+</span>
      <p>Affordable Water Purifier Service Charges</p>
    </div>

  </div>

</section> */}


<section class="working-hours-section">
  <div class="container">
    <div class="working-hours-box">
      <h2>Working Hours</h2>

      <div class="working-time">
        <span>Monday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Tuesday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Wednesday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Thursday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Friday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Saturday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Sunday</span>
        <strong>Closed</strong>
      </div>
    </div>
  </div>
</section>

{/* WATER PURIFIER FAQ SECTION */}

{/* <section className="purifier-faq-section">

  <div className="purifier-faq-title">

    <h4>
      FAQ
    </h4>

    <h1>
      Water Purifier Service Questions
    </h1>

  </div>

  <div className="purifier-faq-container">

  

    <div className="purifier-faq-box">

      <h2>
        What water purifier issues do you repair?
      </h2>

      <p>
        We repair filter issues, water leakage,
        low water flow, motor faults,
        and RO membrane related problems.
      </p>

    </div>

   

    <div className="purifier-faq-box">

      <h2>
        Do you repair all water purifier brands?
      </h2>

      <p>
        Yes, we provide repair and maintenance
        support for all major water purifier brands.
      </p>

    </div>

 

    <div className="purifier-faq-box">

      <h2>
        Do you provide doorstep water purifier service?
      </h2>

      <p>
        Yes, our technicians provide fast doorstep
        water purifier repair and inspection support.
      </p>

    </div>

  

    <div className="purifier-faq-box">

      <h2>
        How quickly can I book a purifier service?
      </h2>

      <p>
        You can instantly book your water purifier
        service through phone call or WhatsApp support.
      </p>

    </div>

  

    <div className="purifier-faq-box">

      <h2>
        Do you provide filter replacement support?
      </h2>

      <p>
        Yes, we provide professional filter
        replacement and maintenance support.
      </p>

    </div>

   

    <div className="purifier-faq-box">

      <h2>
        Are your purifier service charges affordable?
      </h2>

      <p>
        Yes, we provide transparent and affordable
        water purifier repair pricing with quality service.
      </p>

    </div>

  </div>

</section> */}


<section className="service-info-section">
  <div className="service-info-container">

    <div className="service-info-header">
      <span>SERVICE DETAILS</span>
      <h2>Service Information</h2>

      <p>
        Clear information about our service charges and repair process.
      </p>
    </div>

    <div className="service-charge-box">

      <div className="service-check-icon">
        ✓
      </div>

      <div className="service-charge-content">

        <h3>Service Charge</h3>

        <div className="service-price">
          ₹400+
        </div>

        <p>
          The applicable basic service charge starts from ₹400.
          If any spare parts need replacement, our technician will
          explain the issue and inform you of the applicable cost
          before proceeding.
        </p>

        <div className="service-approval-note">
          <span>✓</span>

          <p>
            Spare part replacement or additional repair work will be
            carried out only after receiving your approval.
          </p>
        </div>

      </div>

    </div>

  </div>
</section>  
   
   </>
  );
}

export default WaterPurifier;